module.exports = __webpack_public_path__ + "img/user.044c3a92.svg";